import React from "react";
import * as Redux from "react-redux";

import "./../styles/login.css";

import * as pageActions from "./../actions/pageActions";

export class Login extends React.Component {
	constructor(props) {
		super(props);
		var {dispatch} = this.props;
		this.state = { error: null, processing: false, rememberMe: false };
		
		dispatch(pageActions.setPage(window.location.pathname + window.location.search));
	}


   render() {
		document.title = "Login";

		window.location = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "login";
		return <div></div>;
	}
}

export default Redux.connect(state => {
	return state;
})(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js